import type { CreateAppFunction, Plugin } from 'vue'
import { createApp as createVueApp } from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import vClickOutside from 'click-outside-vue3'

import { domPurifyPluginOptions } from '@app/shared/config/dom-purify-vue'
import getPiniaInstance from '@app/shared/pinia/instance'
import TooltipDirective from '@app/shared/vue/directives/tooltip'
import AutoResizeDirective from '@app/shared/vue/directives/autoresize.js'
import FocusDirective from '@app/shared/vue/directives/focus'
import MentionableDirective from '@app/shared/vue/directives/mentionable.js'
import XhrModalHtmlDirective from '@app/shared/vue/directives/xhr-modal-html'
import { HighlightUpdatesPlugin } from '@app/shared/vue/plugins/flash-updates'
import I18nPlugin from '@app/shared/vue/plugins/i18n.js'
import ImagesRequirePlugin from '@app/shared/vue/plugins/images-require.js'
import TurbolinksPlugin from '@app/shared/vue/plugins/turbolinks'
import environment from '@app/utils/environment'

export const createApp: CreateAppFunction<Element> = (Component, props) => {
  const app = createVueApp(Component, props)
  const pinia = getPiniaInstance()

  app.directive('autoresize', AutoResizeDirective)
  app.directive('focus', FocusDirective)
  app.directive('mentionable', MentionableDirective)

  if (environment.__DEV__) {
    app.use(HighlightUpdatesPlugin)
  }

  app.use(I18nPlugin)
  app.use(ImagesRequirePlugin as Plugin)
  app.directive('tooltip', TooltipDirective)
  app.directive('xhr-modal-html', XhrModalHtmlDirective)
  app.use(VueDOMPurifyHTML, domPurifyPluginOptions)
  app.use(TurbolinksPlugin)
  app.use(pinia)
  app.use(vClickOutside)

  return app
}
